
<script>
import UnitInfo__sensors_default from "@/components/units/sensors/UnitInfo__sensors_default.vue";
export default {
    name: "UnitInfo__sensors_ignition",
    extends: UnitInfo__sensors_default,
    computed:{
        title() {
            return this.$t('Unit.sensors.Ignition')
        },
        value() {
            return this.unitLmsgSensors.ignition?.text;//this.$t('Not defined')
        },
        icon() {
            return this.showIcon ? 'unit_dashboard__ignition' : false
        }
    },
}
</script>

<style scoped>

</style>